import React, { useMemo } from "react";
import { FieldValues } from "react-hook-form";
import FingridTestGenericPlanningsForm from "../shared/FingridTestGenericPlanningsForm";
import { computeDefaultValuesFinlandAfrr, finlandAfrrPlanningConfigurations } from "./config";

export interface PlanningFormProps {
  initialData: FieldValues;
}

const TestFingridAfrrPlanningsForm: React.FC<PlanningFormProps> = ({ initialData }) => {
  const defaultValues = useMemo(() => computeDefaultValuesFinlandAfrr(initialData), [initialData]);

  return (
    <FingridTestGenericPlanningsForm
      initialData={initialData}
      configs={finlandAfrrPlanningConfigurations}
      defaultValues={defaultValues}
      lockSocEndDate
    />
  );
};

export default TestFingridAfrrPlanningsForm;
